import React from "react";
import useTranslation from "next-translate/useTranslation";

import { Box, Link as ChakraLink, Heading, Flex } from "@chakra-ui/react";

import Link from "next/link";
import { BlogPostsMainData } from "@/Types/types";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import HorizontalCardImg from "./HorizontalCardImg";

import { configFile } from "@/config";

interface Props {
  posts: BlogPostsMainData[];
}

function BlogLatestPosts({ posts }: Props) {
  const categoryLink = posts[0].attributes.category.data[0].attributes.slug;
  const { t } = useTranslation("common");

  return (
    <Box
      as="section"
      width="100%"
      paddingBottom={{ base: "60px", lg: "80px" }}
      paddingTop={{ base: "60px", lg: "80px" }}
      position="relative"
      bgColor="gray.50"
    >
      <Flex
        maxWidth="1216px"
        margin="0 auto"
        width="90%"
        mb="32px"
        justifyContent="space-between"
        alignItems="center"
        flexDir={{ base: "column", md: "row" }}
      >
        <Heading
          as="h2"
          width="100%"
          textAlign={{ base: "center", md: "left" }}
        >
          {t("homepage.title")}
        </Heading>
        <ChakraLink prefetch={false}
          as={Link}
          href={`categoria/${categoryLink}`}
          color={configFile.primaryAccentColor}
          fontSize="20px"
          fontWeight="600"
          minW="180px"
          alignItems="center"
          columnGap="3px"
          display={{ base: "none", md: "flex" }}
        >
          {t("homepage.articles.button")}
          <ArrowForwardIcon position="relative" top="2px" />
        </ChakraLink>
      </Flex>
      <Flex
        maxWidth="1216px"
        margin="0 auto"
        width="90%"
        columnGap="32px"
        rowGap="32px"
        flexWrap="wrap"
        justifyContent="flex-start"
      >
        {posts.map((post: BlogPostsMainData, index: number) => (
          <HorizontalCardImg key={index} post={post} />
        ))}
      </Flex>
    </Box>
  );
}

export default BlogLatestPosts;
